import { IconButton, Text } from 'shell/components';

const IconButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>IconButton</Text>
            <IconButton kind={'edit'} size={'small'} variant={'square'} />
            <IconButton kind={'edit'} size={'medium'} variant={'square'} />
            <IconButton kind={'edit'} size={'large'} variant={'square'} />

            <IconButton disabled kind={'edit'} size={'small'} variant={'square'} />
            <IconButton disabled kind={'edit'} size={'medium'} variant={'square'} />
            <IconButton disabled kind={'edit'} size={'large'} variant={'square'} />

            <IconButton kind={'edit'} size={'undersized'} variant={'circle'} />
            <IconButton kind={'edit'} size={'xsmall'} variant={'circle'} />
            <IconButton kind={'edit'} size={'small'} variant={'circle'} />
            <IconButton kind={'edit'} size={'medium'} variant={'circle'} />
            <IconButton kind={'edit'} size={'large'} variant={'circle'} />

            <IconButton disabled kind={'edit'} size={'undersized'} variant={'circle'} />
            <IconButton disabled kind={'edit'} size={'xsmall'} variant={'circle'} />
            <IconButton disabled kind={'edit'} size={'small'} variant={'circle'} />
            <IconButton disabled kind={'edit'} size={'medium'} variant={'circle'} />
            <IconButton disabled kind={'edit'} size={'large'} variant={'circle'} />
        </>
    );
};

export default IconButtonDemo;
